/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Dialog from 'components/Dialog';
import Card from 'components/Card';
import LoadBlur from 'components/LoadBlur';
import CardActions from 'components/Card/Actions';
import { Box } from '@mui/system';
import RowSpacer from 'components/RowSpacer';
import OTP from './OneTimePwd';

const styles1 = {
  dialogBody: {
    textAlign: 'center',
  },
  cardLayout: {
    borderRadius: 15,
    backgroundColor: '#FFFFFF',
    textAlign: 'center',
    padding: '20px 50px',
  },
  cardText: {
    color: '#000',
    paddingBottom: 24,
  },
  button: {
    borderRadius: 15,
    backgroundColor: '#0076BB',
    color: '#FFFFFF',
  },
  buttonRed: {
    borderRadius: 15,
    backgroundColor: '#EF493E',
    color: '#FFFFFF',
  },
  left: {
    width: '5%',
  },
  cardActions: {
    display: 'inline-flex',
    paddingBottom: 24,
  },
  dint: {
    fontFamily: 'jost',
    fontWeight: 400,
    fontSize: '16px',
    textAlign: 'center',
    marginBottom: '6%',
    marginTop: '6%',
    color: '#424141',
  },
  resend: {
    color: 'blue',
    textDecoration: 'underline',
    cursor: 'pointer',
    fontWeight: '600',
  },
  createAccount: {
    color: '#080808',
    fontSize: '24px',
    textAlign: 'center',
    fontWeight: '700',
    fontFamily: 'NewOrderBold',
    marginBottom: '4%',
  },
  descriptionNew: {
    fontFamily: 'jost',
    fontSize: '16px',
    lineHeight: '20px',
    textAlign: 'center',
    marginBottom: '5%',
    color: '#656565',
  },
  errortext: {
    fontFamily: 'NewOrderBold',
    // fontWeight: '700',
    fontSize: '18px',
    textAlign: 'center',
    marginBottom: '5%',
    color: '#EF493E',
    marginTop: '6%',
  },
};
const EmailChange = ({ onSendotp, isEmailChange, setIsEmailChange, newEmail, isActive, timer, setIsActive, setTimer, errorText, setOtp, otp, onEmailChange, setErrorText }) => {

  useEffect(() => {
    let intervals;
    if (isActive && timer > 0) {
      intervals = setInterval(() => {
        setTimer(timer - 1);
      }, 1000);
    } else if (timer === 0) {
      setIsActive(false);
    }

    return () => clearInterval(intervals);
  }, [isActive, timer]);

  const remainingMinutes = Math.floor(timer / 60);
  const remainingSeconds = timer % 60 < 9 ? `0${timer % 60}` : timer % 60;
  return (
    <Dialog
      onRequestClose={() => {
        setIsEmailChange(false);
      }}
      open={isEmailChange}
      bodyStyle={styles1.dialogBody}
    >
      <Card style={styles1.cardLayout} rounded>
        <LoadBlur loading={false}>
          <div style={styles1.errortext}>{errorText}</div>
          <div style={styles1.createAccount}>Enter your four digit code</div>
          <div style={styles1.descriptionNew}>
            We’ve sent a code to your email
            <br />({newEmail})
          </div>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
              alignItems: 'center',
            }}
          >
            <OTP
              separator={<span>-</span>}
              value={otp}
              onChange={setOtp}
              length={4}
            />
          </Box>
          <div style={styles1.dint}>
            Didn’t receive?{' '}
            <span
              style={{
                ...styles1.resend,
                pointerEvents: isActive ? 'none' : 'inherit',
                opacity: isActive ? 0.3 : 1,
              }}
              onClick={onSendotp}
            >
              Resend
            </span>
            {isActive && (
              <span
                style={{
                  marginLeft: '2%',
                  fontFamily: 'jost',
                  fontSize: '16px',
                  fontWeight: 'bold',
                }}
              >
                {' '}
                {`${remainingMinutes}:${remainingSeconds}`}
              </span>
            )}
          </div>
          <CardActions noTopPadding style={styles1.cardActions}>
            <Button
              style={styles1.buttonRed}
              variant='contained'
              onClick={() => {
                setErrorText('');
                setIsEmailChange(false);
                setOtp('');
              }}
            >
              CANCEL
            </Button>
            <RowSpacer />

            <Button
              style={styles1.button}
              variant='contained'
              disabled={otp.toString().length !== 4}
              onClick={onEmailChange}
            >
              SUBMIT
            </Button>
          </CardActions>
        </LoadBlur>
      </Card>
    </Dialog>
  );
};

EmailChange.propTypes = {
  onEmailChange: PropTypes.func.isRequired,
  onSendotp: PropTypes.func.isRequired,
  isEmailChange: PropTypes.object.isRequired,
  setIsEmailChange: PropTypes.object.isRequired,
  newEmail: PropTypes.object.isRequired,
  isActive: PropTypes.object.isRequired,
  timer: PropTypes.object.isRequired,
  setIsActive: PropTypes.object.isRequired,
  setTimer: PropTypes.object.isRequired,
  errorText: PropTypes.object.isRequired,
  setOtp: PropTypes.object.isRequired,
  otp: PropTypes.object.isRequired,
  setErrorText: PropTypes.object.isRequired,
};
export default EmailChange;
